module.exports = __webpack_public_path__ + "static/media/calendar.c03bdcce.svg";